import type {
  InventorySystemProfileToVenueDTO,
  ListFilterValues,
  VenueDTO,
} from '../../../types'
import { matchesVenueFilters } from '../../helpers/matchesVenueFilters'

export function filterInventorySystemProfileToVenues(
  mappings: readonly InventorySystemProfileToVenueDTO[],
  venues: readonly VenueDTO[],
  values: ListFilterValues
): InventorySystemProfileToVenueDTO[] {
  const venueById = new Map(venues.map((venue) => [venue.id, venue]))
  return mappings.filter(
    (mapping) =>
      (!values.profile ||
        mapping.inventorySystemProfileId === values.profile) &&
      (!values.tenantGroup || mapping.tenantGroupId === values.tenantGroup) &&
      matchesVenueFilters(
        mapping.venueId,
        venueById.get(mapping.venueId),
        values.venue ?? '',
        values.venueType ?? ''
      )
  )
}
